import { MailOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Card, Input } from "antd";
import React from "react";

export default function Profile() {
  const user = {
    fullName: 'Dimitri Signe',
    email: 'dimitri.signe@ejara.africa',
    tel: '237698949789'
  }
  return (
    <div>
      <Card hoverable className="flex justify-start items-start">
        <div className="flex justify-start items-center">
          <Avatar
            size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
            icon={<UserOutlined />}
          />
          <h1 className="text-2xl font-bold ml-2">{user?.fullName}</h1>
        </div>
      </Card>

      <Card hoverable className="flex justify-center items-center mt-10 p-6">
        <div className="flex justify-between w-full">
          <h1 className="text-center text-2xl font-bold">Profile</h1>
        </div>
        <div className="w-full  mt-5">
          <div className="flex justify-start items-center">
            <h3 className="mr-2">Email Address</h3>
            <Input className="w-3/4" prefix={<MailOutlined />} placeholder="Email Address" readOnly value={user?.email} />
          </div>
        </div>
        <div className="w-full  mt-5">
          <div className="flex justify-start items-center">
            <h3 className="mr-2">Phone Number</h3>
            <Input className="w-3/4" prefix={<PhoneOutlined />} placeholder="Phone Number" readOnly value={user?.tel} />
          </div>
        </div>
      </Card>
    </div>
  )
}
